<script setup>
import {onMounted} from 'vue'
import { useRouter } from 'vue-router'
let router = useRouter()
onMounted(() => {
        //  level 200 供应商 300 商家

    // if (JSON.parse(localStorage.userInfo || '{}').level == 200) {
    //     router.push({
    //       path: '/agent'
    //     })
    // } else  if (JSON.parse(localStorage.userInfo || '{}').level == 300){
    //   router.push({
    //     path: '/merChant'
    //   })
    // } else {
    //    router.push({
    //     path: '/user'
    //   }) 
    // }
})
</script>

<template>
  <div>
  <router-view></router-view>
  </div>
</template>

<script setup>

</script>

<style>
#app{
    height: 100%;
}
table {
            border-collapse: collapse;
            border-color: #e8e8e8;
        }
        th {
            color: #333;
            background-color: #E0EEFF;
        }
        th, td {
            padding: 12px 20px;
            font-size: 12px;
        }
        td:hover {
            background-color: #f5f5f5;
        }
</style>
